var exports = {
  "F": "CtaBanner__KfrYCX",
  "i": "CtaBanner__container__AVyM3C",
};

module.exports = exports;
